module.exports = __webpack_public_path__ + "static/media/leaderboard-selected.6ff20aac.svg";